import {Test} from 'lib/test'
import * as React from 'react'
import {CircularProgressBar} from "app/Components/ProgressBar";
import { ClameisrForm } from '.';

type PreviewProps = {
    test: Test
}

export class ClameisrRawData extends React.Component<PreviewProps> {
    public render = () => <>
        {this.props.test && this.props.test.content ?
            <ClameisrForm data={this.props.test.content.data} preview={true} /> : <CircularProgressBar/>
        }
    </>
}